import { create } from "zustand"

interface AppErrorStoreState {
    appError?: string
    setAppError: (appError?: string) => void
    clear: () => void
}

export const useAppErrorStore = create<AppErrorStoreState>((set) => ({
    setAppError: (appError?: string) => set({ appError }),
    clear: () => set({ appError: undefined }),
}))
